import { Root, Content, Trigger } from '@radix-ui/react-collapsible';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';
import { content, trigger } from './collapsible.css';

export const CollapsibleContent = ({
  duration = 300,
  children,
}: PropsWithChildren<{ duration?: number }>) => {
  return (
    <Content
      className={content}
      style={{
        animationDuration: `${duration}ms`,
      }}
    >
      {children}
    </Content>
  );
};

export const CollapsibleTrigger = ({
  className,
  ...props
}: React.ComponentPropsWithRef<typeof Trigger>) => (
  <Trigger className={clsx(trigger, className)} {...props} />
);

export { Root as Collapsible };
